import { animated } from '@react-spring/web';
import styled from 'styled-components';

export const AnimatedBox = styled(animated.div as any)``;

export const Root = styled.div`
    overflow: hidden;
`;
